import { MembersAreaWidgetPluginService } from './members-area-widget-plugin';
export { routerDataServiceFactory } from './route-data';
export { createWidgetPluginExports } from './widget-plugin-exports';
export function createMembersAreaWidgetPluginService() {
  return new MembersAreaWidgetPluginService();
}
//# sourceMappingURL=index.js.map